<template>
    <div class="dia_container">
        <div class="dev_set">
            <div class="dev_set_header cl">
                <div class="l sea">
                    <el-input v-model="query" icon="search" :on-icon-click="devSearchHandle" @keyup.enter.native="devSearchHandle" placeholder="请输入姓名搜索"></el-input>
                </div>
            </div>
            <div class="dev_set_content cl">
                <div class="org_tree l">
                    <el-tree :expand-on-click-node="false" :data="orgData" :props="defaultProps" @node-click="handleOrgNodeClick"></el-tree>
                </div>
                <div class="dev_select l">
                    <el-transfer :titles="['待选人员：', '已选人员：']" v-model="devSelected" :data="devOptions"></el-transfer>
                </div>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="saveDevSet">保存</el-button>
        </div>
    </div>
</template>
<script>
    import { errorMessage } from '../../../util'
    export default {
        props: ['param'],
        data() {
            return {
                query: '',
                orgData: [],
                curTotalDevOptions: [],
                devOptions: [],
                devSelected: [],
                defaultProps: {
                    children: 'children',
                    label: 'organizationname'
                }
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                this.getTenantPlatAccount({init: true,bindStatus: '1'})
                this.getTenantPlatAccount({init: true,bindStatus: '2'})
                // 初始化组织结构
                this.initOrgTreeData()
            },
            // 保存开发人员设置
            saveDevSet() {
                this.$http.post(`/platserv/tenant/bindTenantPlatAccount`,{
                    tenantcode: this.param.tenantCode,
                    plataccountcodes: this.devSelected
                }).then(res => {
                    this.$message.success('保存成功')
                    this.cancel()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 搜索开发人员
            devSearchHandle() {
                this.getTenantPlatAccount({userName: this.query})
            },
            // 组织结构树点击
            handleOrgNodeClick(data) {
                this.getTenantPlatAccount({codePath: data.codepath})
            },
            // 初始化组织结构
            initOrgTreeData() {
                this.$http.post(`/platserv/organiztion/tree`,{}).then(res => {
                    this.orgData = res.data.resp_data
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 获取开发人员信息
            getTenantPlatAccount(data = {}) {
                this.$http.post(`/platserv/tenant/findTenantPlatAccount`,{
                    username: data.userName,
                    codepath: data.codePath,
                    bindstatus: data.bindStatus,
                    tenantcode: this.param.tenantCode
                }).then(res => {
                    let parseResData = this.parseTenantPlatAccount(res.data.resp_data.data, data.init)
                    if(data.init){
                        this.curTotalDevOptions = this.curTotalDevOptions.concat(res.data.resp_data.data)
                    }else {
                        this.devOptions = []
                    }
                    this.devOptions = this.devOptions.concat(parseResData)
                    if(data.bindStatus === '1'){  //已绑定人员
                        let arr = []
                        res.data.resp_data.data.forEach(function(item){
                            arr.push(item.plataccountcode)
                        })
                        this.devSelected = arr
                    }
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 将账号信息转换格式
            parseTenantPlatAccount(data, init) {
                let ret = []
                let _this = this
                let hasDev = function(code){
                    let ret = false
                    data.forEach(function(item){
                        if(item.plataccountcode === code){
                            ret = true
                        }
                    })
                    return ret
                }
                data.forEach(function(item){
                    let obj = {
                        key: item.plataccountcode,
                        label: item.username1,
                    }
                    ret.push(obj)
                })
                if(!init){
                    this.devSelected.forEach(function(item){
                        _this.curTotalDevOptions.forEach(function(item1){
                            if(item === item1.plataccountcode){
                                if(!hasDev(item)){
                                    let obj = {
                                        key: item1.plataccountcode,
                                        label: item1.username1,
                                    }
                                    ret.push(obj)
                                }
                            }
                        })
                    })
                }
                return ret
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SettingDeveloper.vue?44cde13e